const WarningLevel = Object.freeze({
  /**  0*/
  Validation: 0,
  /**  1*/
  Warning: 1,
  /**  2*/
  Error: 2,
});
export default WarningLevel;
